




















































































































import { momentInst } from "@core/filters";
import { computed, onMounted, onUnmounted, Ref, ref } from "@vue/composition-api";
import { storeToRefs } from "pinia";
import { useAutoPayments } from "@/stores/webmaster/finance/modal/autoPaymentsStore";
import FinanceAutoPaymentTemplate from "@/components/Webmaster/Finance/modal/FinancePaymentModal/FinanceAutoPaymentTemplate.vue";
import { DialogProgrammatic } from "buefy";
import i18n from "@core/plugins/i18n";
import { actionWithToast } from "@/helpers/actionWithToast";
import { defineExpose } from "@vue/runtime-dom";
import { FinancesAutoPaymentsListData } from "@core/store/types/webmaster/finances/modal/financeAutoPaymentsList";
import { FinanceOutTransactionType } from "@core/store/types/webmaster/finances/modal/enum/financeOutTransactionType";
import { FinanceTypeEnum } from "@core/store/types/webmaster/finances/modal/enum/financeTypeEnum";
import { FinanceDayEnum } from "@core/store/types/webmaster/finances/modal/enum/financeDayEnum";
import { useRequisiteStore } from "@/stores/webmaster/finance/modal/requisiteStore";
import { RequisiteStatusEnum } from "@core/store/types/webmaster/finances/modal/enum/requisiteStatusEnum";
import { useWait } from "@/stores/common/waitStore";
import CustomCollapse from "@/components/Common/Controls/CustomCollapse.vue";
import FinancePaymentList from "@/components/Webmaster/Finance/modal/FinancePaymentModal/FinancePaymentList.vue";
import LLoading from "@/components/Common/LLoading.vue";
import { Requisite } from "@core/store/types/webmaster/finances/modal/financeRequisites";
import SelectedRequisiteInfo from "@/components/Webmaster/Finance/modal/FinancePaymentModal/selectedRequisiteInfo.vue";
import i18nPlugin from "@core/plugins/i18n";
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const autoPaymentsStore = useAutoPayments();
  const {
    options,
    data
  } = storeToRefs(autoPaymentsStore);
  const requisiteStore = useRequisiteStore();
  const {
    data: requisites
  } = storeToRefs(requisiteStore);
  onMounted(async () => {
    if (!requisites.value?.items) {
      requisiteStore.GET_REQUISITES();
    }
    if (!data.value?.items) {
      await autoPaymentsStore.GET_AUTO_OUT_TRANSACTIONS();
    }
    if (data.value?.items?.length) {
      activeCollapse.value = 0;
    }
  });
  const isLoadingSubmit = useWait(autoPaymentsStore, "ACTION_AUTO_OUT_TRANSACTION");
  const isLoadingRequisite = useWait(requisiteStore, "GET_REQUISITES");
  const isLoadingAutoPayment = useWait(autoPaymentsStore, "GET_AUTO_OUT_TRANSACTIONS");
  const loadingItemId = ref(null) as Ref<string | null>;
  const autoPayoutTemplateRef = ref();
  const activeCollapse = ref(1);
  const isLoading = computed(() => isLoadingRequisite.value || isLoadingAutoPayment.value);
  const unavailableCurrencies = computed(() => {
    return data.value?.items.map((item: FinancesAutoPaymentsListData) => item.requisite.paymentSystem?.currency);
  });
  const requisitesForAutoPayments = computed(() => {
    return requisites.value?.items?.filter((item: Requisite) => !data.value?.items.map(({
      requisite
    }: FinancesAutoPaymentsListData) => requisite.id).includes(item.id)).map((item: Requisite) => {
      return {
        ...item,
        isDisabled: unavailableCurrencies.value?.includes(item.paymentSystem.currency) || item.paymentSystem.isDisabled || item.status !== RequisiteStatusEnum.APPROVED
      };
    }).sort((a: Requisite, b: Requisite) => {
      const getPriority = (item: Requisite) => {
        if ([RequisiteStatusEnum.CREATED, RequisiteStatusEnum.WAITING_FOR_APPROVE].includes(item.status)) return 0;
        if (item.status === RequisiteStatusEnum.DENIED) return 3;
        if (item.paymentSystem.isDisabled) return 4;
        if (unavailableCurrencies.value?.includes(item.paymentSystem.currency)) return 2;
        return 1;
      };
      return getPriority(a) - getPriority(b);
    });
  });
  const selectedRequisite = computed(() => {
    return requisites.value.items?.find((item: Requisite) => item.id === options.value.requisiteId) || {};
  });
  function selectActiveAutoPayment(item: Requisite) {
    editAutoPayment(data.value.items.find(({
      requisite
    }: FinancesAutoPaymentsListData) => requisite.id === item.id));
  }
  function selectItem(item: Requisite) {
    options.value = {
      daysOfWeek: [FinanceDayEnum.TUESDAY, FinanceDayEnum.FRIDAY],
      type: FinanceTypeEnum.DAILY,
      outTransactionType: FinanceOutTransactionType.SUM,
      requisiteId: item.id,
      datepickerDates: null,
      isEdit: false,
      time: 840,
      sum: item.paymentSystem.minimalPayout
    };
  }
  function editAutoPayment(row: FinancesAutoPaymentsListData): void {
    const time = momentInst(row.time).hours() * 60;
    const type = row.isDaily || row.outTransactionType === FinanceOutTransactionType.SUM ? FinanceTypeEnum.DAILY : row.daysOfWeek?.length ? FinanceTypeEnum.WEEKLY : FinanceTypeEnum.DATE;
    options.value = {
      ...row,
      datepickerDates: row.daysOfMonth?.map(el => momentInst("01.01.2024").add(el - 1, "days").toDate()),
      daysOfWeek: row.daysOfWeek ?? [],
      requisiteId: row.requisite.id,
      isEdit: true,
      type,
      time
    };
  }
  function deleteAutoPayment(id: string) {
    DialogProgrammatic.confirm({
      title: i18n.t("webmaster.finances.autoPaymentModal.messages.title") as string,
      message: i18n.t("webmaster.finances.autoPaymentModal.messages.confirm") as string,
      confirmText: i18n.t("common.buttons.delete") as string,
      cancelText: i18n.t("common.buttons.cancel") as string,
      type: "is-danger is-light",
      onConfirm: async () => {
        try {
          loadingItemId.value = data.value.items.find((item: FinancesAutoPaymentsListData) => item.id === id)?.requisite.id;
          await actionWithToast(autoPaymentsStore.DELETE_AUTO_OUT_TRANSACTIONS(id), "webmaster.finances.autoPaymentModal.messages.deleteAutoPayment");
          options.value.requisiteId = null;
          if (!data.value.items.length) {
            activeCollapse.value = 1;
          }
        } finally {
          loadingItemId.value = null;
        }
      }
    });
  }
  async function submit() {
    if (autoPayoutTemplateRef.value?.isValid) {
      await autoPayoutTemplateRef.value?.submit();
      options.value.requisiteId = null;
      activeCollapse.value = 0;
    }
  }
  function removeRequisite(id: string) {
    DialogProgrammatic.confirm({
      title: i18nPlugin.t("webmaster.finances.paymentModal.payment.deleteConfirm.title") as string,
      message: i18nPlugin.t("webmaster.finances.paymentModal.payment.deleteConfirm.message") as string,
      confirmText: i18nPlugin.t("common.buttons.delete") as string,
      cancelText: i18nPlugin.t("common.buttons.cancel") as string,
      type: "is-danger is-light",
      onConfirm: async () => {
        try {
          loadingItemId.value = id;
          await actionWithToast(requisiteStore.REMOVE_REQUISITE(id), "webmaster.finances.paymentModal.payment.messages.deleteRequisite");
        } finally {
          loadingItemId.value = null;
        }
      }
    });
  }
  onUnmounted(() => {
    options.value.requisiteId = null;
  });
  return Object.assign({
    RequisiteStatusEnum,
    options,
    data,
    isLoadingSubmit,
    loadingItemId,
    autoPayoutTemplateRef,
    activeCollapse,
    isLoading,
    requisitesForAutoPayments,
    selectedRequisite,
    selectActiveAutoPayment,
    selectItem,
    deleteAutoPayment,
    removeRequisite
  }, {
    submit
  });
};
__sfc_main.components = Object.assign({
  CustomCollapse,
  FinancePaymentList,
  SelectedRequisiteInfo,
  FinanceAutoPaymentTemplate,
  LLoading
}, __sfc_main.components);
export default __sfc_main;
